import {AxiosResponse, CancelToken} from 'axios';
import {Reminder} from '../backend/interfaces/reminder';
import {PostReminder} from '../backend/requests/post-reminder';
import {PutReminder} from '../backend/requests/put-reminder';
import {BackendApiManager} from '../managers/backend-api';

export class EntityUserRemindersRepository {
  private readonly path: string;

  constructor(entityId: string, seniorId: string) {
    this.path = `/entities/${encodeURIComponent(entityId)}/users/${encodeURIComponent(seniorId)}/reminders`;
  }

  public async get(limit: number, skip: number, _seniorId: string, cancelToken?: CancelToken) {
    const response: AxiosResponse<Array<Reminder>> = await BackendApiManager.instance.get<
      Array<Reminder>
    >(`${this.path}?skip=${skip}&limit=${limit}`, {cancelToken});
    const totalCount = Number.parseInt(response.headers['x-total-count'] || '', 10);
    return {
      data: response.data,
      totalCount: Number.isNaN(totalCount) ? response.data.length : totalCount,
    };
  }

  public async create(body: PostReminder): Promise<Reminder> {
    const response = await BackendApiManager.instance.post<Reminder>(this.path, body);
    return response.data;
  }

  public async updateById(id: string, body: PutReminder): Promise<Reminder> {
    const response = await BackendApiManager.instance.put<Reminder>(
      `${this.path}/${encodeURIComponent(id)}`,
      body
    );
    return response.data;
  }

  public async updateActiveStatusById(id: string, isActive: boolean): Promise<Reminder> {
    const response = await BackendApiManager.instance.patch<Reminder>(
      `${this.path}/${encodeURIComponent(id)}/active/${isActive}`
    );
    return response.data;
  }

  public async deleteById(id: string): Promise<void> {
    await BackendApiManager.instance.delete<void>(`${this.path}/${encodeURIComponent(id)}`);
  }
}
